var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessenger = function SvgMessenger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.683 20v-3.562C1.436 14.74 0 12.155 0 9.26 0 4.145 4.477 0 10 0s10 4.145 10 9.26c0 5.113-4.477 9.258-10 9.258-1.03 0-2.025-.144-2.96-.412L3.683 20Zm-.144-7.61 5.393-5.667L11.52 9.35l4.854-2.626-5.362 5.667-2.565-2.673L3.54 12.39Z",
    fill: "#fff"
  })));
};
export default SvgMessenger;